import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconElectrocardiogram: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconElectrocardiogram"><Path d="M9.0157 1.26172L5.47468 10.9995H1V12.4995H6.52532L8.9843 5.73735L15.0151 23.0759L18.5406 12.4995H23V10.9995H17.4594L14.9849 18.4231L9.0157 1.26172Z" fill="currentColor"/></CentralIconBase>;
});

export default IconElectrocardiogram;
